import { Radius } from '@ghosts-inc/design-system/constants';
import { Ghost } from '@ghosts-inc/design-system/icons';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { WishlistsWithMetadata } from '../../wishlist/types';
import { FlatBuyerPreferences } from '../types';
import { AddToWishlistButton } from './AddToWishlistButton';
import { AddToWishlistTypography } from './AddToWishlistTypography';
import { MoreRecommendationsTypography } from './MoreRecommendationsTypography';

type Props = {
  categoriesPromise: Promise<{ [key: string]: string[] }>;
  preferencesPromise: Promise<FlatBuyerPreferences>;
  wishlistsPromise: Promise<WishlistsWithMetadata>;
};

export const AddToWishlistBanner = ({
  categoriesPromise,
  preferencesPromise,
  wishlistsPromise,
}: Props) => {
  return (
    <Grid size={{ mobile: 4, smallTablet: 12 }} role="grid">
      <Stack
        bgcolor="lightFill.hover"
        border={1}
        borderColor="lightBorder.default"
        borderRadius={Radius.large}
        justifyContent="center"
        minHeight={216}
        overflow="hidden"
        position="relative"
        px={{ mobile: 7, smallTablet: 3, tablet: 5, desktop: 8 }}
        py={6}
      >
        <MoreRecommendationsTypography
          color="typographyDarkSecondary"
          mb={{ mobile: 2, tablet: 0 }}
          textAlign={{ mobile: 'center', smallTablet: 'left' }}
          variant="bodyLargeLight"
          zIndex={1}
        />
        <Stack
          columnGap={2}
          direction={{ mobile: 'column', tablet: 'row' }}
          justifyContent="space-between"
          alignItems={{ mobile: 'center', smallTablet: 'start', tablet: 'center' }}
          zIndex={1}
          rowGap={4.5}
        >
          <AddToWishlistTypography
            variant="h2"
            flex={1}
            textAlign={{ mobile: 'center', smallTablet: 'left' }}
          />
          <AddToWishlistButton
            categoriesPromise={categoriesPromise}
            preferencesPromise={preferencesPromise}
            size="large"
            wishlistsPromise={wishlistsPromise}
          />
        </Stack>
        <Box
          position="absolute"
          right={{ smallTablet: -42 }}
          left={{ mobile: '50%', smallTablet: 'unset' }}
          sx={{
            transform: { mobile: 'translateX(-50%)', smallTablet: 'unset' },
          }}
        >
          <Ghost
            sx={(theme) => ({
              fontSize: { desktop: 585, mobile: 365 },
              color: theme.palette.lightBorder.default,
            })}
          />
        </Box>
      </Stack>
    </Grid>
  );
};
